const config = {
  "secretKey": "$Hj7aF#k9l*D@v!3G",
  "numberOfRows": 100,
  "authMethod": "JWT",
  "endPoint":
    process.env.REACT_APP_TARGET === "dev"
      ? `${window.location.origin}/Millada_BE_ai_millennium`      // TEST 10.10.10.122: same-origin (:448) -> bez CORS (REACT_APP_TARGET=dev)
      : process.env.NODE_ENV === "production"
        ? `${window.location.origin}/MillAI_BE`        // PROD/DEV: origin = protokol+host aktuálnej stránky (http aj https, ľubovoľný host)
        : "http://localhost:8080",                           // lokalne debugovanie
  "subDir" : "/",
  "imgAllowed": false,
  "msgReviewsAllowed" : true,
  // „Všetky moje priečinky“ v Dokumentoch (hľadanie naprieč priečinkami) — zatiaľ vypnuté, nie je doladené
  "allFoldersAllowed": false,
  "jwtAllowed": true,
  "adAllowed" : true,
  "adConfig": {
    "clientId": "038ac896-f99e-47a6-bc24-99f1eca24e22",   // Entra app ai_millennium_sk_SSO (predtým b95da68a-…); musí sedieť s BE config.json ad_azure.clientId
    "authority":"https://login.microsoftonline.com/f9eb7c2a-37a3-4a1e-aa8b-d5bd0ecbe9ab",
    "redirectUri": window.location.origin, // protokol+host aktuálnej stránky (http na localhoste, https v prode)
    "scopes": ["User.Read"]
  }
}
export default config;